import { LoadingController } from '@ionic/angular';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  public translate = inject(TranslateService);
  private loading: HTMLIonLoadingElement;
  private isShowing = false;

  constructor(private loadingController: LoadingController) {}

  async present(message: string = ''): Promise<void> {
    const msg: string = message ? message : this.translate.instant('GLOBAL.LOADING');
    if (!this.isShowing) {
      this.isShowing = true;
      this.loading = await this.loadingController.create({
        message: msg,
        mode: 'md',
        spinner: 'crescent',
        backdropDismiss: false,
      });
    } else {
      this.isShowing = true;
      this.loading.message = message;
    }
    return await this.loading.present();
  }

  async dismiss(): Promise<void> {
    if (this.loading && this.isShowing) {
      this.isShowing = false;
      await this.loading.dismiss();
      this.loading = null;
    }
    return;
  }
}
